import { directionFromDelta } from './sorenAnswerCards.js'

export type WhatIfDigest = {
  reason?: string | null
  delta?: { formatted?: string; amount?: number } | null
  base?: { lowest_point?: { formatted?: string } | null; lowest_week?: string | null } | null
  what_if?: { lowest_point?: { formatted?: string } | null; lowest_week?: string | null } | null
}

export default function SorenWhatIfAnswerCard({ digest }: { digest?: WhatIfDigest | null }) {
  const base = digest?.base?.lowest_point?.formatted || '—'
  const next = digest?.what_if?.lowest_point?.formatted || '—'
  const week = digest?.what_if?.lowest_week || '—'
  const delta = digest?.delta?.formatted || '—'
  const dir = directionFromDelta(digest?.delta)
  const dirBit = dir !== 'unchanged' ? ` ${dir}` : ''

  return (
    <div className="soren-whatif-answer" data-testid="soren-whatif-answer">
      <p data-testid="soren-whatif-lowest">{base} → {next}</p>
      <p data-testid="soren-whatif-week">Week of {week}</p>
      <p data-testid="soren-whatif-delta">{delta}{dirBit}</p>
    </div>
  )
}
